import type { ButtonProps } from '@base-ui/react';

import { Button as BaseButton } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Icon } from '../Icon/Icon';
import { Spinner } from '../Spinner/Spinner';
import { loadingButtonStyle } from './Button.css';
import { getSharedButtonClassNames, type SharedButtonProps } from './Button.utils';

type Props = Omit<ButtonProps, 'children'> &
  SharedButtonProps & {
    loading?: boolean;
  };

export const Button = (props: Props) => {
  const { children, disabled, emphasis, icon, iconPlacement, loading = false, ...delegated } = props;

  const iconSize = 22;

  return (
    <BaseButton
      {...delegated}
      className={clsxs(
        getSharedButtonClassNames({ children, emphasis, icon, iconPlacement }),
        loading && loadingButtonStyle,
        delegated.className,
      )}
      disabled={disabled || loading}
      focusableWhenDisabled={delegated.focusableWhenDisabled ?? loading}
    >
      {icon && !loading && <Icon name={icon} size={iconSize} />}
      {loading && <Spinner size={iconSize} />}

      {children !== undefined && <span>{children}</span>}
    </BaseButton>
  );
};
